"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check16"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var VisuallyHidden = _interopRequireWildcard(require("@radix-ui/react-visually-hidden"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBListItem = _interopRequireDefault(require("../HBListItem"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _variables = require("../../styles/variables");
var _HBMenu = require("./HBMenu.constants");
var _HBMenu2 = require("./HBMenu.styles");
var _excluded = ["item", "size", "dropdownReferenceType"],
  _excluded2 = ["content", "placement", "offsetX", "customStyle"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBMenuItem = function HBMenuItem(_ref) {
  var item = _ref.item,
    size = _ref.size,
    _ref$dropdownReferenc = _ref.dropdownReferenceType,
    dropdownReferenceType = _ref$dropdownReferenc === void 0 ? 'item' : _ref$dropdownReferenc,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var showRightIcon = item.setTextBeforeIcon && item.icon || item.rightIcon || item.isSelected;
  var testId = item.testId,
    testIdName = item.testIdName;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'menu-item',
    componentName: 'HBMenuItem'
  });
  var tooltipId = (0, _react.useMemo)(function () {
    return (0, _lodash.uniqueId)("".concat(finalTestId || 'menu-item', "-tooltip-"));
  }, [finalTestId]);
  var ConditionalWrapper = (0, _react.useMemo)(function () {
    var Wrapper = function Wrapper(_ref2) {
      var children = _ref2.children;
      var content = item.itemWrapper ? item.itemWrapper({
        children: children
      }) : children;
      var hasTooltip = item.tooltip && !item.itemWrapper;
      if (hasTooltip) {
        var _ref3 = item.tooltip,
          tooltipContent = _ref3.content,
          _ref3$placement = _ref3.placement,
          placement = _ref3$placement === void 0 ? 'right' : _ref3$placement,
          _ref3$offsetX = _ref3.offsetX,
          offsetX = _ref3$offsetX === void 0 ? placement === 'left' || placement === 'right' ? 16 : 0 : _ref3$offsetX,
          customStyle = _ref3.customStyle,
          tooltipProps = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({
          target: content,
          placement: placement,
          offsetX: offsetX,
          openTrigger: "hover",
          openOnFocus: true,
          customStyle: _objectSpread({
            zIndex: _variables.Z_INDEX.MENU + 1
          }, customStyle)
        }, tooltipProps), tooltipContent), /*#__PURE__*/_react["default"].createElement(VisuallyHidden.Root, {
          id: tooltipId
        }, tooltipContent));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, content);
    };
    return Wrapper;
  }, [item, tooltipId]);
  var DropdownComponent = _HBMenu.dropdownReferenceTypesMap[dropdownReferenceType];
  var hasTooltip = !!item.tooltip;
  var useNativeDisabled = item.disabled && !hasTooltip;
  return /*#__PURE__*/_react["default"].createElement(ConditionalWrapper, null, /*#__PURE__*/_react["default"].createElement(DropdownComponent, {
    disabled: useNativeDisabled ? true : undefined,
    "aria-disabled": item.disabled ? true : undefined,
    "aria-describedby": hasTooltip ? tooltipId : undefined,
    asChild: true,
    onClick: item.disabled ? function (e) {
      return e.preventDefault();
    } : undefined,
    onSelect: item.disabled ? function (e) {
      return e.preventDefault();
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement(_HBListItem["default"], (0, _extends2["default"])({}, (item === null || item === void 0 ? void 0 : item.onClick) && !item.disabled && {
    onClick: function onClick(e) {
      var _item$onClick;
      e.stopPropagation();
      item === null || item === void 0 || (_item$onClick = item.onClick) === null || _item$onClick === void 0 || _item$onClick.call(item, e);
    }
  }, {
    selected: item.isSelected,
    disabled: useNativeDisabled,
    theme: (0, _HBMenu.getHBListItemTheme)(item.theme),
    size: (0, _HBMenu.getHBListItemSize)(size),
    subtext: item.description,
    prefix: !item.setTextBeforeIcon && item.icon && /*#__PURE__*/_react["default"].createElement(_HBMenu2.StyledIcon, {
      "data-set-default-fill-color": item.shouldUseIconDefaultFill
    }, item.icon),
    suffix: showRightIcon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.isSelected ? /*#__PURE__*/_react["default"].createElement(_HBMenu2.StyledIcon, {
      "data-selected": true
    }, /*#__PURE__*/_react["default"].createElement(_Check["default"], null)) : (item.setTextBeforeIcon && item.icon || item.rightIcon) && /*#__PURE__*/_react["default"].createElement(_HBMenu2.StyledIcon, {
      "data-set-default-fill-color": item.shouldUseIconDefaultFill
    }, item.icon || item.rightIcon)) : undefined,
    "data-testid": finalTestId
  }, props), item.title)));
};
var _default = exports["default"] = HBMenuItem;
//# sourceMappingURL=HBMenuItem.js.map